<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import mixin from '@mixins/app';

export default {
  mixins: [mixin],
};
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
</style>
